import React from 'react'

import { ZariContext } from '_zari/context'

import { Button, Col, Row, Portlet, Table } from '_zari/core'

import * as ProductoService from 'services/producto.service'

import { DownloadAxiosFile } from 'utils'

import CodigoFormGroup from './formGroups/codigo'
import NombreFormGroup from './formGroups/nombre'
import CategoriaFormGroup from './formGroups/categoria'
import FechaCreacionFormGroup from './formGroups/fechaCreacion'

import * as Modals from './modals'

const portletBreadcrumbs = [{ name: 'Precios' }]

const ListaPreciosProductosPage = () => {
  const __zariContext = React.useContext(ZariContext)

  const editarDataRef = React.useRef({})

  const [codigo, setCodigo] = React.useState('')
  const [nombre, setNombre] = React.useState('')
  const [categoria, setCategoria] = React.useState('')
  const [fechaCreacion, setFechaCreacion] = React.useState('')

  const [mostrarAsignarPrecioModal, setMostrarAsignarPrecioModal] = React.useState(false)
  const [mostrarImportarPrecioModal, setMostrarImportarPrecioModal] = React.useState(false)

  const [listaPresentaciones, setListaPresentaciones] = React.useState([])

  const buscarxFiltros = React.useCallback(() => {
    if (!codigo && !nombre) {
      __zariContext.snack('error', 'Ingresar código o nombre para realizar búsqueda.')
      return
    }

    __zariContext.loader.open('Buscando presentaciones')

    ProductoService.obtenerPresentacionesAsInfoPrecios({
      codigo: codigo,
      nombre: nombre,
      idCategoria: categoria,
      fechaCreacion: fechaCreacion
    })
      .then(({ data }) => {
        if (data) {
          setListaPresentaciones(data)
        } else {
          setListaPresentaciones([])
        }
      })
      .catch(({ data: { error } }) => __zariContext.snack('error', error))
      .finally(() => {
        __zariContext.loader.close()
      })
  }, [__zariContext, codigo, nombre, categoria, fechaCreacion])

  const clickBuscar = React.useCallback(() => {
    buscarxFiltros()
  }, [buscarxFiltros])

  const clickEditar = React.useCallback(row => {
    editarDataRef.current = row
    setMostrarAsignarPrecioModal(true)
  }, [])

  const clickImportarPrecios = React.useCallback(() => {
    setMostrarImportarPrecioModal(true)
  }, [])

  const clickDescargarInforme = React.useCallback(() => {
    __zariContext.loader.open('Descargando informe precios')
    ProductoService.descargarInformePrecios()
      .then(({ data, headers }) => {
        DownloadAxiosFile.downloadAsBlob(data, headers)
      })
      .finally(() => {
        __zariContext.loader.close()
      })
  }, [__zariContext])

  return (
    <>
      <Portlet>
        <Portlet.Header
          title='Precios'
          breadcrumbs={portletBreadcrumbs}
          buttons={[
            { name: 'Descargar informe', onClick: clickDescargarInforme },
            { name: 'Importar precios', onClick: clickImportarPrecios }
          ]}
        />
        <Portlet.Body>
          <Row>
            <Col sm={9} md={6} lg={5} xl={4}>
              <CategoriaFormGroup value={categoria} onChange={e => setCategoria(e.target.value)} />
              <CodigoFormGroup value={codigo} onChange={e => setCodigo(e.target.value)} />
              <NombreFormGroup value={nombre} onChange={e => setNombre(e.target.value)} />
              <FechaCreacionFormGroup value={fechaCreacion} onChange={e => setFechaCreacion(e.target.value)} />
            </Col>
            <Col sm={3} lg={2}>
              <Row>
                <Col xs={12}>
                  <Button onClick={clickBuscar} block>
                    Buscar
                  </Button>
                </Col>
              </Row>
            </Col>
          </Row>
          <Row className='mt-3'>
            <Col md={12}>
              <Table
                maxRowsShown={15}
                filas={listaPresentaciones}
                headRows={[
                  { id: 'categoria', label: 'CATEGORIA' },
                  { id: 'codigo', label: 'CÓDIGO' },
                  { id: 'nombre', label: 'NOMBRE' },
                  { id: 'uMedida', label: 'U. MEDIDA' },
                  { id: 'options', label: '' }
                ]}
                rowTemplate={row => (
                  <Table.Row hover key={row._id}>
                    <Table.Cell>{row.categoria || '--'}</Table.Cell>
                    <Table.Cell>{row.codigo || '--'}</Table.Cell>
                    <Table.Cell>{row.nombre || '--'}</Table.Cell>
                    <Table.Cell>{row.unidadMedida || '--'}</Table.Cell>
                    <Table.Cell>
                      <Table.Dropdown>
                        {({ handleClose }) => [
                          <Table.Dropdown.Item key='editar' handleClose={handleClose} onClick={e => clickEditar(row)}>
                            Editar
                          </Table.Dropdown.Item>
                        ]}
                      </Table.Dropdown>
                    </Table.Cell>
                  </Table.Row>
                )}
              />
            </Col>
          </Row>
        </Portlet.Body>
      </Portlet>
      {mostrarAsignarPrecioModal && (
        <Modals.AsignarPrecioModal
          handleClose={e => setMostrarAsignarPrecioModal(false)}
          show={mostrarAsignarPrecioModal}
          modalData={editarDataRef.current}
        />
      )}
      {mostrarImportarPrecioModal && (
        <Modals.ImportarExcelModal
          handleClose={e => setMostrarImportarPrecioModal(false)}
          show={mostrarImportarPrecioModal}
          reloadTable={buscarxFiltros}
        />
      )}
    </>
  )
}

export default ListaPreciosProductosPage
